import { render } from "./RoomFilter.vue?vue&type=template&id=865147e6"
import script from "./RoomFilter.vue?vue&type=script&lang=js"
export * from "./RoomFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__